import { Button as CMSButton, Spinner } from '@cmsgov/ds-medicare-gov';
import React from 'react';
import { PropsWithChildren } from 'react';
import { buttonClick, linkClick } from '../analytics';
import cloneObject from '../functions/clone.object';

interface ButtonProps {
    id?: string
    displayAs: 'link' | 'button'
    color: 'teal' | 'blue' | 'white'
    size?: 'big' | 'small'
    fill?: 'solid' | 'outlined' | ''
    /** description of what button does for analytics - should be an href if button navigates to a url */
    analyticsDescription?: string
    onClick: Function
    isDisabled?: boolean
    isLoading?: boolean
    style?: React.CSSProperties
    variation?: string
}

const Button = (props: PropsWithChildren<ButtonProps>) => {
    let classNames = '';
    let size = null;

    if (props.displayAs === 'link') {
        classNames += ' ds-c-button--transparent ';
        if (props.color === 'teal')
            classNames += ' ds-c-button--primary ';
        else if (props.color === 'blue')
            classNames += ' ds-c-button--primary-alt ';
        else
            classNames += ' ds-c-button--inverse ';

    } else if (props.displayAs === 'button') {
        if (props.size === 'big')
            size = 'big';
        if (props.color === 'teal')
            classNames += props.fill === 'outlined' ? ' ds-c-button--primary-outline ' : ' ds-c-button--primary ';
        else if (props.color === 'blue')
            classNames += props.fill === 'outlined' ? ' ds-c-button--primary-alt-outline ' : ' ds-c-button--primary-alt ';

    }
    let buttonProps: any = cloneObject(props);
    delete buttonProps.displayAs;
    delete buttonProps.isDisabled;
    delete buttonProps.size;
    delete buttonProps.onClick
    delete buttonProps.analyticsDescription;
    delete buttonProps.isLoading;

    const onClickWithAnalytics = (e: any) => {
        const text = e.currentTarget.textContent.trim();
        if (props.displayAs === 'link') {
            linkClick(text, props.analyticsDescription);
        } else {
            buttonClick(text, props.analyticsDescription);
        }
        props.onClick(e);
    }

    return <>
        <CMSButton
            className={classNames}
            disabled={props.isDisabled}
            size={size}
            onClick={onClickWithAnalytics}
            {...buttonProps}
        >
            {props.isLoading &&
         <Spinner className="ds-u-margin-right--1"/>}
            {props.children}
        </CMSButton>
    </>;
}

export default Button;